import React from "react";
//#region types
import { PageFooterProps } from "models/propTypes/commonPropTypes";
import { WizardProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import PageFooter from "../pageFooter";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const WizardFormFooter: React.FC<PageFooterProps & { wizardProps: WizardProps }> = (props) => {
  const { wizardProps } = props;

  return (
    <PageFooter
      {...props}
      onBackButtonClick={wizardProps.currentStep ? () => wizardProps.goToStep(wizardProps.currentStep - 1) : undefined}
      onNextButtonClick={
        wizardProps.stepCount - 1 > wizardProps.currentStep
          ? () => wizardProps.goToStep(wizardProps.currentStep + 1)
          : undefined
      }
      className={cssExports.wizardFooter}
      showHelp
    />
  );
};
export default WizardFormFooter;
